import { INLINE_API_ERROR_OPTIONS } from '@/core/api/requestErrorMode';
import { getClientApi, getExecutorApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { TransferProfilePhoneRequest } from '@/core/generated/api';
import type { ProfilePhoneTransferTarget } from '../model/types';

/** Переносит профиль выбранного типа на другой телефон */
export const profilePhoneTransferService = {
    /** Изменяет телефон существующей учётной записи профиля */
    async transfer(
        target: ProfilePhoneTransferTarget,
        request: TransferProfilePhoneRequest
    ): Promise<void> {
        try {
            if (target.kind === 'client') {
                await getClientApi()
                    .transferClientPhone({
                        profileId: target.profileId,
                        transferProfilePhoneRequest: request,
                    }, INLINE_API_ERROR_OPTIONS);
            } else {
                await getExecutorApi()
                    .transferExecutorPhone({
                        profileId: target.profileId,
                        transferProfilePhoneRequest: request,
                    }, INLINE_API_ERROR_OPTIONS);
            }
        } catch (error: unknown) {
            rethrowHandledApiError(error, 'inline');
        }
    },
};
